<!--
 * www.cloudscope.cn
 * Copyright (c) 2019. All Rights Reserved.
-->
<!--
 * @Author: liuchang
 * @Date: 2019-08-14 20:27:01
 * @Description: 菜单管理
 -->
<template>
    <div class="con-f-div">
        <div class="top">
            <el-header class="top-header">
                <div class="header-content">
                    <h3 class="header-content-title">菜单管理查询</h3>
                    <el-button class="header-content-btn" @click="shiftFormShow">
                        <icon name="double-arrow-up" class="svg-icon-btn" v-show="formShow"></icon>
                        <icon name="double-arrow-down" class="svg-icon-btn" v-show="!formShow"></icon>
                    </el-button>
                </div>
            </el-header>
            <div class="top-content" v-show="formShow">
                <el-form ref="form" label-position="left" :model="form" label-width="80px" :inline="true">
                    <el-form-item label="名称" prop="name">
                        <el-input v-model="form.name" placeholder="输入名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="链接" prop="url">
                        <el-input v-model="form.url" placeholder="输入链接" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="父级菜单" prop="parMenu">
                        <el-select v-model="form.parMenu" placeholder="全部" clearable>
                            <el-option
                                v-for="item in menuList"
                                :value="item.id"
                                :key="item.id"
                                :label="item.name"
                            >{{ item.name }}</el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div class="top-footer">
                <div class="left-btn">
                    <el-button type="primary" size="small" @click="showDialog()">新增</el-button>
                </div>
                <div class="right-btn">
                    <el-button type="primary" size="small" class="reset-btn" @click="resetForm">重置</el-button>
                    <el-button type="primary" size="small" style="width:70px" @click="loadlist(1)">查询</el-button>
                </div>
            </div>
        </div>
        <div class="list tab-drive">
            <List @showDialog="showDialog" @loadlist="loadlist" :title="tableTitle" ref="MenuList"></List>
        </div>
        <Add
            @hideDialog="hideDialog"
            @closeAddModal="closeAddModal"
            v-show="isShow"
            ref="addMenu"
            :addTitle="addTitle"
        ></Add>
    </div>
</template>
<script>
import List from '@/components/MenuManagement/List';
import Add from '@/components/MenuManagement/Add';
export default {
    name: 'MenuManagement',
    components: {
        List,
        Add
    },
    data () {
        return {
            form: {
                name: '',
                url: '',
                parMenu: ''
            },
            tableTitle: '菜单管理列表',
            menuList: [],
            addTitle: '新增菜单',
            isShow: false,
            isDelete: false,
            selectLoading: global.loading,
            formShow: true // 查询区域显示
        };
    },
    mounted () {
        this.getAll();
    },
    methods: {
        /**
         * @author: liuc
         * @description: 隐藏弹窗
         * @param {}
         */
        hideDialog () {
            this.isShow = false;
        },
        /**
         * @author: liuc
         * @description:显示新增弹窗
         * @param {number}
         */
        showDialog (id) {
            this.isShow = true;
            var type = 0;
            this.$refs.addMenu.queryMenuList();
            if (this.isNotNull(id)) {
                this.addTitle = '编辑菜单';
                type = 1;
            } else {
                this.addTitle = '新增菜单';
            }
            this.$refs.addMenu.open(type, id);
        },
        /**
         * @author: liuc
         * @description: 刷新表格
         * @param {operateType} 判断是否为sucess
         */
        async closeAddModal (operateType) {
            if (operateType === 'success') {
                // 刷新表格
                await this.$refs.MenuList.loadTableRefresh();
            }
        },
        /**
         * @author: liuc
         * @description: 获取数据表
         * @param {queryBean} 查询列表参数
         */
        async loadTableData (queryBean) {
            await this.$refs.MenuList.loadTable(queryBean);
        },
        /**
         * @author: liuc
         * @description: 获取所有菜单，用于“父级菜单”
         * @param {}
         */
        async getAll () {
            let response = await this.$api.MenuManagement.getAll();
            this.menuList = response.data;
        },
        /**
         * @author: liuc
         * @description:重置
         * @param {}
         */
        resetForm () {
            this.$refs.form.resetFields();
            this.loadlist(1);
        },
        /**
         * @author: liuc
         * @description: 查询菜单
         * @param {currentPage} 当前页数
         */
        loadlist (currentPage) {
            global.loading.select = true;
            let filters = [];
            let name = this.tableSearchNode(
                'sub.name',
                'like',
                [this.form.name],
                'String'
            );
            // eslint-disable-next-line no-console
            console.log(this.tableSearchNode);
            let url = this.tableSearchNode(
                'sub.url',
                'like',
                [this.form.url],
                'String'
            );
            filters.push([url]);
            filters.push([name]);
            if (this.isNotNull(this.form.parMenu)) {
                let parentid = this.tableSearchNode(
                    'sub.parentid',
                    'eq',
                    [this.form.parMenu],
                    'String'
                );
                filters.push([parentid]);
            }
            let queryBean = this.buildQueryBean(currentPage, this.pageSize, filters);
            this.loadTableData(queryBean);
        },
        /**
         * @author: liuc
         * @description: 判断传入的值是否为空
         * @param {target} 传入的值
         */
        isNotNull (target) {
            if (target) {
                return true;
            } else {
                return false;
            }
        },
        /**
         * @author: liuc
         * @description: 菜单管理查询表单显示隐藏
         * @param {}
         */
        shiftFormShow () {
            if (this.formShow) {
                this.formShow = false;
            } else {
                this.formShow = true;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.el-header {
  font-size: 24px;
}
.con-f-div {
  box-sizing: border-box;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .top {
    border: 1px solid #e1e8e9;
    margin-right: 29px;
    .top-header {
      display: flex;
      align-items: center;
      height: 70px;
      padding-left: 29px;
      background: #f4f7fb;
      .header-content {
        flex: 1;
        display: flex;
        align-items: center;
        .header-content-title {
          font-size: 24px;
          font-weight: 400;
          color: #333;
        }
      }
    }
    .top-content {
      width: 80%;
      padding-top: 20px;
      padding-left: 29px;
      .el-form-item {
        margin-bottom: 10px;
        /deep/ .el-input {
          width: 320px;
        }
      }
    }
    .top-footer {
      border-top: 1px solid #e1e8e9;
      padding: 10px 20px;
      overflow: hidden;
      .left-btn {
        float: left;
      }
      .right-btn {
        float: right;
        .reset-btn {
          background: #fff;
          color: #4970ad;
        }
      }
    }
  }
  .list {
    flex: 1;
    overflow: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// ./src/views/MenuManagement.vue